import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import PeopleIcon from "@mui/icons-material/People";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import ReceiptIcon from "@mui/icons-material/Receipt";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import CasinoIcon from "@mui/icons-material/Casino";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import MessageIcon from "@mui/icons-material/Message";
import SettingsIcon from "@mui/icons-material/Settings";
import HistoryIcon from "@mui/icons-material/History";
import QuizIcon from "@mui/icons-material/Quiz";
import SmartDisplayIcon from "@mui/icons-material/SmartDisplay";
import BarChartIcon from "@mui/icons-material/BarChart";
import BlockIcon from "@mui/icons-material/Block";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import GroupsIcon from "@mui/icons-material/Groups";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import PersonSearchRoundedIcon from "@mui/icons-material/PersonSearchRounded";

export const SIDEBAR_WIDTH = 240;

export const navigationItems = [
  { path: "/admin/analytics", label: "Analytics", icon: BarChartIcon },
  { path: "/admin/users", label: "Profile", icon: PeopleIcon },
  { path: "/admin/profile-center", label: "Profile Center", icon: ManageAccountsIcon },
  { path: "/admin/signup-activity", label: "Signup Activity", icon: PersonSearchRoundedIcon, allowedRoles: ["super_admin", "support_admin"] },
  { path: "/admin/admins", label: "Admins", icon: AdminPanelSettingsIcon, superAdminOnly: true },
  { path: "/admin/transactions", label: "Transactions", icon: ReceiptIcon },
  { path: "/admin/draws", label: "Draws", icon: CasinoIcon, superAdminOnly: true },
  { path: "/admin/winners", label: "Winners List", icon: EmojiEventsIcon, allowedRoles: ["super_admin"] },
  { path: "/admin/tickets", label: "Tickets", icon: ConfirmationNumberIcon },
  { path: "/admin/bulk-email", label: "Bulk Email", icon: EmailRoundedIcon, superAdminOnly: true },
  { path: "/admin/messages", label: "Messages", icon: MessageIcon },
  { path: "/admin/influencers", label: "Influencers", icon: GroupsIcon, superAdminOnly: true },
  { path: "/admin/referrers", label: "Referrers", icon: GroupsIcon, allowedRoles: ["super_admin", "finance_admin"] },
  { path: "/admin/influencer-terms", label: "Influencer Terms", icon: DescriptionRoundedIcon, superAdminOnly: true },
  { path: "/admin/presenter-accounts", label: "Presenter Accounts", icon: RecordVoiceOverIcon, superAdminOnly: true },
  { path: "/admin/faqs", label: "FAQs", icon: QuizIcon, superAdminOnly: true },
  { path: "/admin/how-to-play", label: "How To Play", icon: SmartDisplayIcon },
  { path: "/admin/social-metrics", label: "Social Metrics", icon: BarChartIcon },
  { path: "/admin/blocked-registration-names", label: "Name Blocks", icon: BlockIcon, superAdminOnly: true },
  { path: "/admin/settings", label: "Settings", icon: SettingsIcon, superAdminOnly: true },
  { path: "/admin/audit-logs", label: "Audit Logs", icon: HistoryIcon, superAdminOnly: true }
];

export function getPageTitle(pathname = "") {
  if (pathname.startsWith("/admin/draws/live/")) {
    return "Live Draw";
  }

  const matchedItem = navigationItems.find((item) => pathname === item.path);

  if (matchedItem) {
    return matchedItem.label;
  }

  if (pathname.startsWith("/admin/user/createuser")) {
    return "Create User";
  }

  if (pathname.startsWith("/admin/user/modify")) {
    return "Modify User";
  }

  if (pathname.startsWith("/admin/user/suspend")) {
    return "Suspend User";
  }

  if (pathname.startsWith("/admin/user/delete")) {
    return "Close Customer Profile";
  }

  if (pathname.startsWith("/admin/admin/create")) {
    return "Create Admin";
  }

  if (pathname.startsWith("/admin/admin/modify")) {
    return "Modify Admin";
  }

  if (pathname.startsWith("/admin/admin/suspend")) {
    return "Suspend Admin";
  }

  if (pathname.startsWith("/admin/admin/delete")) {
    return "Delete Admin";
  }

  return "Admin Dashboard";
}
